import axios from 'axios'

function unwrapList(res) {
  const d = res?.data ?? res
  if (!d) return []
  if (Array.isArray(d)) return d
  if (Array.isArray(d.data)) return d.data
  if (Array.isArray(d.rows)) return d.rows
  if (Array.isArray(d.items)) return d.items
  if (d.data && typeof d.data === 'object') {
    const vals = Object.values(d.data).find(v => Array.isArray(v))
    if (vals) return vals
  }
  return []
}

function unwrapOne(res) {
  const d = res?.data ?? res
  if (!d) return null
  if (d.data && typeof d.data === 'object') return d.data
  return d
}

function str(v) {
  return String(v ?? '').trim()
}

const RingGroupsService = {
  async list(params = {}) {
    return axios.get('ring-groups', { params })
  },

  async get(endpointId, params = {}) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing ring group endpointId')
    return axios.get(`ring-groups/${encodeURIComponent(id)}`, { params })
  },

  async create(payload = {}) {
    return axios.post('ring-groups', payload)
  },

  async update(endpointId, payload = {}) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing ring group endpointId')
    return axios.put(`ring-groups/${encodeURIComponent(id)}`, payload)
  },

  async destroy(endpointId) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing ring group endpointId')
    return axios.delete(`ring-groups/${encodeURIComponent(id)}`)
  },

  async syncMembers(endpointId, members = []) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing ring group endpointId')
    if (!Array.isArray(members)) throw new Error('members must be an array')

    const clean = members
      .filter(m => m && typeof m === 'object')
      .map((m, i) => ({
        user_id: Number.isFinite(m.user_id) ? m.user_id : null,
        ring_order: Number.isFinite(m.ring_order) ? m.ring_order : (i + 1),
        enabled: m.enabled !== undefined ? !!m.enabled : true
      }))
      .filter(m => m.user_id)

    return axios.put(`ring-groups/${encodeURIComponent(id)}/members`, { members: clean })
  },

  unwrapList,
  unwrapOne
}

export default RingGroupsService
